import clientsData from './shared/state';

export default {
  modules: {
    clientsData,
  },
};
